import { ALERT_KEY, TUTORIAL_BUBBLE_KEY, TUTORIAL_KEYS } from './reducers';

export const isAlertShowing = state => !!state.get(ALERT_KEY);

export const getAlertType = state => state.getIn([ALERT_KEY, 'type'], 'None');

export const isVideoAlertShowing = state =>
    isAlertShowing(state) && getAlertType(state) === 'video';

// If the video alert must be watched, then the user should not be able
// to close it
export const isVideoAlertSkippable = state =>
    !state.getIn([ALERT_KEY, 'message', 'disableSkipButton']);

export const isTutorialBubbleShowing = state => {
    // Check through each possible tutorial and see if it is active
    if (state.get(TUTORIAL_BUBBLE_KEY)) {
        for (const key of TUTORIAL_KEYS) {
            if (state.getIn([TUTORIAL_BUBBLE_KEY, key, 'active'])) {
                return true;
            }
        }
    }
    return false;
};
